export default{
    titulo: "Habilitaciones",
    nueva: "Nueva habilitación",
    editar: "Editar habilitación",
    eliminar: "Eliminar habilitación",
    pregEliminar: "¿Confirmas que deseas eliminar la habilitación?",
    estados: {
        "Pendiente": "Pendiente",
        "En trámite": "En trámite",
        "Aprobado": "Aprobado"
    },
    fechaVto: "Fecha de vencimiento",
    observaciones: "Observaciones"     
}